var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    width: "20px",
    fill: "#000000",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.374,265.845l168.152,146.591c1.599-5.25,2.474-10.818,2.474-16.583V117.087L341.374,265.845z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,283.102c7.208-0.015,14.31-2.492,20.11-7.538L499.591,80.739c-10.424-13.076-26.458-21.478-44.481-21.478 H56.89c-18.023,0-34.057,8.401-44.481,21.478L235.89,275.564C241.682,280.61,248.792,283.087,256,283.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,117.087v278.766c0,5.765,0.875,11.333,2.473,16.583l168.152-146.599L0,117.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.474,302.367c-12.432,10.841-28,16.303-43.474,16.288c-15.474,0.015-31.05-5.454-43.474-16.288 l-14.845-12.939L23.151,441.579c9.447,6.978,21.092,11.159,33.739,11.159h398.22c12.647,0,24.291-4.181,33.738-11.159 l-174.53-152.151L299.474,302.367z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.28ab6fe523cde70c68dda302a46b1c9d.svg";
export { ForwardRef as ReactComponent };